import { render, staticRenderFns } from "./ShowroomsForm.vue?vue&type=template&id=0bfc4304&scoped=true&"
import script from "./ShowroomsForm.vue?vue&type=script&lang=js&"
export * from "./ShowroomsForm.vue?vue&type=script&lang=js&"
import style0 from "./ShowroomsForm.vue?vue&type=style&index=0&id=0bfc4304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc4304",
  null
  
)

export default component.exports